import { InputNumber } from 'primereact/inputnumber';
import { classNames } from 'primereact/utils';
import React, { useEffect, useRef, useState } from 'react';
import InfoTooltipTemplate from '../InfoTooltipTemplate';

/**
 * A customizable number input template
 */
const NumberInputTemplate = ({
    name,
    label,
    disabled,
    className,
    labelClassName,
    floatLabel,
    noMargins,
    bottomMargin,
    inline,
    value,
    placeholder,
    onChangeFunction,
    isValid,
    errorMessage,
    focusInput,
    selectInput,
    format = false,
    category,
    infoMessage,
    mode,
}) => {
    const inputRef = useRef();
    const [inputClasses, setInputClasses] = useState(classNames({
        'p-invalid': isValid,
        'w-full': true
    }));
    const [labelClasses, setLabelClasses] = useState(classNames({
        'p-error': isValid,
        'w-full': true,
        'block mb-2': !inline,
        'mr-2': inline,
        'pr-4': infoMessage
    }));

    useEffect(() => {
        // add input classes (if we have any)
        if (className) {
            setInputClasses(inputClasses + ' ' + className);
        }

        // add label classes (if we have any)
        if (labelClassName) {
            setLabelClasses(labelClasses + ' ' + labelClassName);
        }

        // focus on input on load
        if (focusInput) {
            inputRef.current.focus();
        }
        
        // select all input on load
        if(selectInput) {
            inputRef.current.select();
        }
    }, []);

    const inputField = <InputNumber id={name} value={value} disabled={disabled} placeholder={placeholder}
        onChange={(e) => onChangeFunction(name, e.value, category, mode !== 'decimal')}
        className={inputClasses}
        format={format}
        maxLength={mode === 'decimal' ? 10 : 7}
        minFractionDigits={mode === 'decimal' ? 2 : 0}
        maxFractionDigits={mode === 'decimal' ? 2 : 0}
        allowEmpty
        inputRef={inputRef}
    />;

    return (
        <div className={(!noMargins ? ('mb-' + (bottomMargin || '5')) : '') + (infoMessage ? ' relative' : '')}>
            {floatLabel
                ? <>
                    <span className="p-float-label">
                        {inputField}
                        {label && <label htmlFor={name} className={labelClasses}>{label}</label>}
                        {infoMessage && <div className="top-right-icon">
                            <InfoTooltipTemplate target={'tooltip-' + name} message={infoMessage} className="ml-2" />
                        </div>}
                    </span>

                    {errorMessage}
                </>

                : <>
                    {label && <label htmlFor={name} className={labelClasses} title={ labelClassName == 'one-line' ? label : null }>{label}</label>}
                    {infoMessage && <div className="top-right-icon">
                            <InfoTooltipTemplate target={'tooltip-' + name} message={infoMessage} className="ml-2" />
                    </div>}
                    {inputField}
                    {errorMessage}
                </>
            }
        </div>
    );
};

export default NumberInputTemplate;
